import { IconClock, IconDownload, IconSparkles } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export function SuccessStep({
  eligibleCampaigns,
  nextRunTime,
  goalLabel,
  targetAcos,
  modeLabel,
}: {
  eligibleCampaigns: number;
  nextRunTime: string;
  goalLabel: string;
  targetAcos: string;
  modeLabel: string;
}) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="flex h-full flex-col px-[22px] pb-[22px] pt-7">
      <div className="flex items-center gap-5 px-5">
        <span className="flex size-[72px] shrink-0 items-center justify-center rounded-[14px] bg-ink text-white">
          <IconSparkles className="size-7" stroke={1.8} />
        </span>
        <div>
          <p className="flex items-center gap-1.5 text-[10px] font-medium text-green-11">
            <span className="size-1.5 rounded-full bg-green" /> {t("policyDialog.success.badge")}
          </p>
          <h3 className="mt-1 text-[20px] font-semibold leading-6 tracking-[-0.025em] text-ink">
            {t("policyDialog.success.title")}
          </h3>
          <p className="mt-1 max-w-[410px] text-[11px] leading-4 text-muted-foreground">
            {t("policyDialog.success.description", { eligibleCampaigns })}
          </p>
        </div>
      </div>
      <div className="mt-[52px] grid h-[92px] shrink-0 grid-cols-[1.5fr_1fr] divide-x divide-line overflow-hidden rounded-[10px] border border-line">
        <div className="flex items-center gap-3 px-4">
          <span className="flex size-9 items-center justify-center rounded-[8px] bg-subtle">
            <IconClock className="size-4" />
          </span>
          <div>
            <p className="text-[9px] text-muted-foreground">{t("policyDialog.success.firstRun")}</p>
            <p className="text-[13px] font-semibold text-ink">
              {t("policyDialog.success.time", { time: nextRunTime })}
            </p>
            <p className="text-[9px] text-muted-foreground">
              {t("policyDialog.success.afterRefresh")}
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-center px-4">
          <p className="text-[9px] text-muted-foreground">
            {t("policyDialog.success.activePolicy")}
          </p>
          <p className="text-[11px] font-semibold text-ink">{goalLabel}</p>
          <p className="mt-1 text-[9px] text-muted-foreground">
            {t("policyDialog.success.policySummary", {
              targetAcos,
              mode: modeLabel,
            })}
          </p>
        </div>
      </div>
      <p className="mt-7 flex items-center justify-center gap-2 text-[10px] text-muted-foreground">
        <IconDownload className="size-3.5" /> {t("policyDialog.success.inheritNote")}
      </p>
    </div>
  );
}
